import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  TextField,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Save } from "@mui/icons-material";

export default function AttendanceDialog({
  open,
  onClose,
  record,
  onRecordChange,
  onSave,
  saving,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} fullWidth maxWidth="sm">
      <DialogTitle>Update attendance</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="subtitle1" gutterBottom>
            {record?.formattedDate || record?.date}
          </Typography>

          <Box sx={{ my: 2 }}>
            <Select
              fullWidth
              displayEmpty
              value={record?.status || "Unchecked"}
              onChange={(e) =>
                onRecordChange({
                  ...record,
                  status: e.target.value,
                })
              }
            >
              <MenuItem value="Present">Present</MenuItem>
              <MenuItem value="Absent">Absent</MenuItem>
              <MenuItem value="Unchecked">Unchecked</MenuItem>
            </Select>
          </Box>

          <TextField
            fullWidth
            label="Notes"
            multiline
            rows={3}
            value={record?.notes || ""}
            onChange={(e) =>
              onRecordChange({
                ...record,
                notes: e.target.value,
              })
            }
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={saving}
          startIcon={<Save />}
        >
          {saving ? "Saving…" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
